import React from "react";

function About() {
  return (
    <div id="aboutMe">
      <div className="left">
        <h1 className="title">About Me</h1>
        <h2>
          <span className="newLine bold">Hi, I'm Sebas.</span>
          I'm a Computational Technology Engineering student, currently enrolled
          on my 5th semester in Tec de Monterrey, CCM.
        </h2>
      </div>
      <div className="right">
        <p>
          Throught my more than two years of experience, I have been part of
          many projects that have excelled between my peers and I have
          participated in competitions like HackMTY2020.
        </p>
        <p className="title">I have experience in: </p>
        <div className="languages">
          <span> Java </span>
          <span>|</span>
          <span> Python </span>
          <span>|</span>
          <span> Unity </span>
          <span>|</span>
          <span> HTML5/CSS3 </span>
          <span>|</span>
          <span> React </span>
          <span>|</span>
          <span> SQL </span>
          <span>|</span>
          <span> C </span>
          <span>|</span>
          <span> Typescript </span>
          <span>|</span>
          <span> Clojure</span>
        </div>
        <p>
          I have also displayed leadership capabilities, ease for expression,
          wit in problem solving, enthusiasm for my work and aptitude for
          negotiation.
        </p>
      </div>
    </div>
  );
}

export default About;
